import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Modal, Divider, Row, Progress, Form, Drawer, Input, Button, Card, Tag } from 'antd';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { L } from '../../../../lib/abpUtility';
import AuthenticationStore from '../../../../stores/authenticationStore';
import Stores from '../../../../stores/storeIdentifier';
import Rules from '../../Validations/defaultValidations.validation';

export interface ILoginFormProps {
    visible: boolean;
    primaryColor: string;
    secondaryColor: string;
    isMobile: boolean;
    authenticationStore: AuthenticationStore;
    location: any;
    onCancel: () => void;
    onLogin: (values: any) => void;
}

export interface ILoginFormState {
    loading: boolean;
}

@inject(Stores.AuthenticationStore)
@observer
class LoginForm extends React.Component<ILoginFormProps, ILoginFormState> {
    state = {
        loading: false
    };

    handleFinish = async (values: any) => {

        this.setState({ loading: true });
        this.handleLogin(values);
        let sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        await sleep(3000);
        this.setState({ loading: false });
    }

    handleLogin = async (values: any) => {
        const { loginModel } = this.props.authenticationStore!;
        await this.props.authenticationStore!.login(values);
        sessionStorage.setItem('rememberMe', loginModel.rememberMe ? '1' : '0');
        const { state } = this.props.location;
        window.location = state ? state.from.pathname : '/';
    }


    

    render() {
        const { visible, isMobile, onCancel } = this.props;

        return (

            <div className="font-face-gm">

                <div>
                    <Modal
                     closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === false ? (visible === true ? true : false) : false}
                        cancelText={L('Cancel')}
                        footer={null}
                        onCancel={onCancel}
                        title={null}>

                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Sign In')}
                        </Divider>
                        <Row style={{ marginBottom: '0px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>

                        <Form style={{ marginTop: '0px', marginBottom: '0px' }} name={'loginForm'} onFinish={(e) => this.handleFinish(e)}>
                            <Card className="font-face-gm" bordered={false} style={{ padding: '0px', marginTop: '0px', marginBottom: '-10px' }}>
                                <div style={{ marginBottom: '60px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1.1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Email')}</Tag>

                                    </div>
                                    <div className="font-face-gm"style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }} 
                                            name={'userNameOrEmailAddress'}
                                            rules={Rules.requiredString}  >
                                            <Input className="font-face-gm" disabled={this.state.loading} size='large' prefix={<UserOutlined className="site-form-item-icon" />}
                                                placeholder={L('Email')} />
                                        </Form.Item>


                                    </div>
                                </div>

                                <div>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>


                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1.1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Password')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item
                                            style={{ margin: '0' }}
                                            name={'password'}
                                            rules={Rules.requiredString}     >
                                            <Input className="font-face-gm" disabled={this.state.loading} size='large'
                                                prefix={<LockOutlined className="site-form-item-icon" />}
                                                type="password"
                                                placeholder={L('Password')} />
                                        </Form.Item>
                                    </div>
                                </div>

                                <div style={{ width: '100%', float: 'right', padding: '0', marginTop: '30px' }}>

                                    <Form.Item style={{ margin: '0', float: 'right' }}>
                                        <Button style={{background: this.props.secondaryColor, borderColor: 'white'}} loading={this.state.loading} size='large' type="primary" shape='round' htmlType="submit" className="font-face-gm">
                                            {L('Sign In')}
                                        </Button>
                                    </Form.Item>
                                    <Form.Item style={{ margin: '0', float: 'left', marginRight: '10px' }}>
                                        <Button disabled={true} size='small' type="dashed" shape='round' htmlType="submit" className="font-face-gm">
                                            {L('Reset Password')}
                                        </Button>
                                    </Form.Item>

                                </div>

                                <Form.Item style={{ float: 'right', marginTop: '15px', marginBottom: '-10px' }}>
                                     
                                </Form.Item>
                            </Card>

                        </Form>

                    </Modal>
                </div>


                <div>
                    <Drawer
                     closable={this.props.isMobile === true ? true : false}
                        onClose={onCancel}
                        visible={isMobile === true ? (visible === true ? true : false) : false}
                        footer={null}
                        width={isMobile === true ? (window.innerWidth * 0.9) : 420}
                        title={null} >
                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Sign In')}
                        </Divider>
                        <Row style={{ marginBottom: '20px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>

                        <Form style={{ marginTop: '0px', marginBottom: '0px' }} name={'loginForm'} onFinish={(e) => this.handleFinish(e)}>
                            <Card className="font-face-gm" bordered={false} style={{ padding: '0px', marginTop: '0px', marginBottom: '-10px' }}>
                                <div style={{ marginBottom: '60px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1.1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Email')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'userNameOrEmailAddress'}
                                            rules={Rules.requiredString}  >
                                            <Input className="font-face-gm" disabled={this.state.loading} size='large' prefix={<UserOutlined className="site-form-item-icon" />}
                                                placeholder={L('Email')} />
                                        </Form.Item>


                                    </div>
                                </div>

                                <div>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>


                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1.1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('PWD')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item
                                            style={{ margin: '0' }}
                                            name={'password'}
                                            rules={Rules.requiredString}     >
                                            <Input className="font-face-gm" size='large'
                                                prefix={<LockOutlined className="site-form-item-icon"  />}
                                                type="password"
                                                disabled={this.state.loading} placeholder={L('Password')} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <br />
                                <div style={{ width: '100%', margin: 'auto', textAlign: 'center', padding: '0', marginTop: '50px' }}>

                                    <Form.Item >
                                        <Button loading={this.state.loading} size='large' 
                                        type="primary" shape='round' htmlType="submit" 
                                        className="font-face-gm" style={{background: this.props.secondaryColor, borderColor: 'white'}}>
                                            {L('Sign In')}
                                        </Button>
                                    </Form.Item>
 
                                    <Form.Item >
                                        <Button size='small' disabled={true} type="dashed" shape='round' 
                                        htmlType="submit" className="font-face-gm">
                                            {L('Reset Password')}
                                        </Button>
                                    </Form.Item>
                                </div>

                            </Card>

                        </Form>
 
                    </Drawer>
                </div>


            </div>
        );
    }

}

export default LoginForm;